import { Component, OnInit, Input } from '@angular/core';
import { ModalService } from '../../services';

@Component({
  selector: 'mgfw-dealer-location',
  templateUrl: './dealer-location.component.html',
  styleUrls: ['./dealer-location.component.css']
})
export class DealerLocationComponent implements OnInit {
  lat:any;
  lng:any;
  zoom: any;
  info=true;
  _dealerList: any;
  addressLine1: any;
  addressLine2: any;
  
  @Input()
  public set dealerList(value: any[]) {
      this._dealerList = value;
  }

  constructor(
    private modalService: ModalService,
  ) { }

  ngOnInit() {
    // this.lat=59.752865; 
    // this.lng=10.126080;
    // this.zoom=15;
    // navigator.geolocation.getCurrentPosition( pos => {
    //   this.lng = +pos.coords.longitude;
    //   this.lat = +pos.coords.latitude;
    // });
  
  }

  public getModType(data: any) {
    this.lat=data.Latitude;
    this.lng=data.Longitude;
    this.zoom=15;
    
  }
  public closeModal(id: string) {
    this.modalService.close(id);
  }


}
